var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashPools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5156 9.34837H21.0156V4.84837",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16626 6.16637C6.93234 5.40029 7.84182 4.7926 8.84275 4.37799C9.84369 3.96339 10.9165 3.75 11.9999 3.75C13.0833 3.75 14.1561 3.96339 15.157 4.37799C16.158 4.7926 17.0674 5.40029 17.8335 6.16637L21.0155 9.34835",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48438 14.6516H2.98438V19.1516",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8336 17.8336C17.0675 18.5997 16.1581 19.2074 15.1571 19.622C14.1562 20.0366 13.0834 20.25 12 20.25C10.9166 20.25 9.84378 20.0366 8.84285 19.622C7.84191 19.2074 6.93244 18.5997 6.16635 17.8336L2.98438 14.6516",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPools);
export default __webpack_public_path__ + "static/media/cash-pools.0e4035ab85ba181e5784d1d29221e897.svg";
export { ForwardRef as ReactComponent };